/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

interface AuthContextType {
  isLoggedIn: boolean;
  userData: any;
  login: (data: any) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState<any>(null);

  // Check for existing login data on component mount
  useEffect(() => {
    const storedAuth = localStorage.getItem("auth");
    if (storedAuth) {
      try {
        const parsedAuth = JSON.parse(storedAuth);
        setIsLoggedIn(true);
        setUserData(parsedAuth);
      } catch (error) {
        console.error("Failed to parse stored auth data:", error);
        localStorage.removeItem("auth");
      }
    }
  }, []);

  const login = (data: any) => {
    setIsLoggedIn(true);
    setUserData(data);
    localStorage.setItem("auth", JSON.stringify(data));
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserData(null);
    localStorage.removeItem("auth");
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userData, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    console.error("useAuth must be used within an AuthProvider");
    // Return a default context instead of throwing
    return {
      isLoggedIn: false,
      userData: null,
      login: () => {},
      logout: () => {}
    };
  }
  return context;
}
